import React, { useEffect, useState } from "react";
import {
    CalendarOutlined,
    SaveOutlined,
    DeleteOutlined,
    ArrowLeftOutlined
} from "@ant-design/icons";

import {
    canSyncHealthData,
    getHealthHistory,
    saveHealthData,
    deleteHealthData
} from "../../api/healthTracking";

export default function LichTaiKham() {
    const [appointmentDate, setAppointmentDate] = useState("");
    const [appointmentTime, setAppointmentTime] = useState("");
    const [place, setPlace] = useState("");
    const [doctor, setDoctor] = useState("");
    const [note, setNote] = useState("");

    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const syncWithAccount = canSyncHealthData();


    /*
     * HIỂN THỊ NGÀY
     */
    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }

        const parts = dateString.split("-");

        if (parts.length !== 3) {
            return dateString;
        }

        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    };


    /*
     * SẮP XẾP LỊCH THEO NGÀY/GIỜ
     */
    const sortAppointments = (data) => {
        return [...data].sort((a, b) => {
            const dateA = new Date(
                `${a.appointmentDate}T${a.appointmentTime || "00:00"}`
            );

            const dateB = new Date(
                `${b.appointmentDate}T${b.appointmentTime || "00:00"}`
            );

            return dateA - dateB;
        });
    };


    /*
     * ĐỌC DỮ LIỆU
     */
    useEffect(() => {
        const loadHistory = async () => {
            setLoading(true);

            if (syncWithAccount) {
                const result = await getHealthHistory(
                    "lich_tai_kham"
                );

                if (result.success) {
                    const data = result.data.map((item) => ({
                        id: item.health_tracking_id,

                        appointmentDate:
                            item.tracking_data?.appointmentDate,

                        appointmentTime:
                            item.tracking_data?.appointmentTime,

                        place:
                            item.tracking_data?.place,

                        doctor:
                            item.tracking_data?.doctor,

                        note:
                            item.tracking_data?.note,

                        createdDate:
                            item.tracking_data?.createdDate,

                        database: true
                    }));

                    setHistory(
                        sortAppointments(data)
                    );
                } else {
                    setHistory([]);
                }
            } else {
                const savedData =
                    localStorage.getItem(
                        "lichTaiKhamHistory"
                    );

                if (savedData) {
                    try {
                        const data =
                            JSON.parse(savedData);

                        setHistory(
                            sortAppointments(data)
                        );
                    } catch (error) {
                        setHistory([]);
                    }
                } else {
                    setHistory([]);
                }
            }

            setLoading(false);
        };

        loadHistory();
    }, [syncWithAccount]);


    /*
     * TẢI LẠI DATABASE
     */
    const reloadAccountHistory = async () => {
        const result = await getHealthHistory(
            "lich_tai_kham"
        );

        if (!result.success) {
            return false;
        }

        const data = result.data.map((item) => ({
            id: item.health_tracking_id,

            appointmentDate:
                item.tracking_data?.appointmentDate,

            appointmentTime:
                item.tracking_data?.appointmentTime,

            place:
                item.tracking_data?.place,

            doctor:
                item.tracking_data?.doctor,

            note:
                item.tracking_data?.note,

            createdDate:
                item.tracking_data?.createdDate,

            database: true
        }));

        setHistory(
            sortAppointments(data)
        );

        return true;
    };


    /*
     * LƯU LỊCH
     */
    const handleSave = async () => {
        if (!appointmentDate) {
            alert("Vui lòng chọn ngày tái khám.");
            return;
        }

        const now = new Date();

        const newRecord = {
            id: Date.now(),

            appointmentDate,

            appointmentTime,

            place: place.trim(),

            doctor: doctor.trim(),

            note: note.trim(),

            createdDate:
                now.toLocaleDateString("vi-VN")
        };


        /*
         * CÓ TOKEN → DATABASE
         */
        if (syncWithAccount) {
            setSaving(true);

            const result = await saveHealthData(
                "lich_tai_kham",
                {
                    appointmentDate:
                        newRecord.appointmentDate,

                    appointmentTime:
                        newRecord.appointmentTime,

                    place:
                        newRecord.place,

                    doctor:
                        newRecord.doctor,

                    note:
                        newRecord.note,

                    createdDate:
                        newRecord.createdDate
                }
            );

            if (!result.success) {
                setSaving(false);

                alert(
                    "Không thể lưu lịch tái khám vào tài khoản. Vui lòng thử lại."
                );

                return;
            }

            await reloadAccountHistory();

            setSaving(false);
        }

        /*
         * KHÔNG TOKEN → LOCALSTORAGE
         */
        else {
            const newHistory =
                sortAppointments([
                    newRecord,
                    ...history
                ]);

            setHistory(newHistory);

            localStorage.setItem(
                "lichTaiKhamHistory",
                JSON.stringify(newHistory)
            );
        }


        setAppointmentDate("");
        setAppointmentTime("");
        setPlace("");
        setDoctor("");
        setNote("");
    };


    /*
     * XÓA
     */
    const handleDelete = async (id) => {
        if (syncWithAccount) {
            const result =
                await deleteHealthData(id);

            if (!result.success) {
                alert(
                    "Không thể xóa lịch tái khám. Vui lòng thử lại."
                );

                return;
            }

            await reloadAccountHistory();
        } else {
            const newHistory =
                history.filter(
                    (item) => item.id !== id
                );

            setHistory(newHistory);

            localStorage.setItem(
                "lichTaiKhamHistory",
                JSON.stringify(newHistory)
            );
        }
    };


    return (
        <div className="max-w-screen-xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">

            {/* QUAY LẠI */}
            <a
                href="/tienich/suc-khoe"
                className="inline-flex items-center text-blue-600 font-semibold text-sm mb-4"
            >
                <ArrowLeftOutlined className="mr-2" />
                Theo dõi sức khỏe
            </a>


            {/* PHẦN ĐẦU */}
            <div className="bg-gradient-to-r from-indigo-600 to-blue-500 rounded-2xl px-5 py-5 md:p-8 text-white">

                <div className="flex items-center">

                    <div className="w-12 h-12 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">
                        <CalendarOutlined />
                    </div>

                    <div className="ml-4">

                        <p className="text-[11px] md:text-sm font-semibold opacity-90">
                            THEO DÕI SỨC KHỎE
                        </p>

                        <h1 className="text-[25px] md:text-3xl font-bold">
                            Lịch tái khám
                        </h1>

                    </div>

                </div>

                <p className="text-[14px] md:text-base mt-4 opacity-90 leading-5 md:leading-normal">
                    Lưu ngày tái khám và thông tin cuộc hẹn để thuận tiện theo dõi.
                </p>

            </div>


            {/* TRẠNG THÁI */}
            {syncWithAccount ? (

                <div className="bg-green-50 border border-green-100 rounded-xl px-4 py-3 mt-4">

                    <p className="text-[13px] text-green-700 font-semibold">
                        ✓ Dữ liệu đang được lưu theo tài khoản
                    </p>

                    <p className="text-[12px] text-green-600 mt-1">
                        Bạn có thể đăng nhập tài khoản này trên thiết bị khác để xem lại lịch tái khám.
                    </p>

                </div>

            ) : (

                <div className="bg-yellow-50 border border-yellow-100 rounded-xl px-4 py-3 mt-4">

                    <p className="text-[13px] text-yellow-700 font-semibold">
                        Dữ liệu đang được lưu trên thiết bị này
                    </p>

                    <p className="text-[12px] text-yellow-600 mt-1">
                        Đăng nhập bằng tài khoản có mật khẩu để lưu lịch tái khám theo tài khoản.
                    </p>

                </div>

            )}


            {/* FORM */}
            <div className="bg-white border rounded-2xl p-4 md:p-6 mt-5">

                <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                    Thêm lịch tái khám
                </h2>

                <p className="text-gray-500 text-sm mt-1">
                    Nhập thông tin cuộc hẹn của bạn.
                </p>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">

                    {/* NGÀY */}
                    <div>

                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Ngày tái khám
                        </label>

                        <input
                            type="date"
                            value={appointmentDate}
                            onChange={(e) =>
                                setAppointmentDate(
                                    e.target.value
                                )
                            }
                            className="w-full h-12 border rounded-xl px-3 outline-none focus:border-blue-500"
                        />

                    </div>


                    {/* GIỜ */}
                    <div>

                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Giờ hẹn
                            <span className="font-normal text-gray-400 ml-1">
                                (không bắt buộc)
                            </span>
                        </label>

                        <input
                            type="time"
                            value={appointmentTime}
                            onChange={(e) =>
                                setAppointmentTime(
                                    e.target.value
                                )
                            }
                            className="w-full h-12 border rounded-xl px-3 outline-none focus:border-blue-500"
                        />

                    </div>

                </div>


                {/* NƠI KHÁM */}
                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Nơi khám
                        <span className="font-normal text-gray-400 ml-1">
                            (không bắt buộc)
                        </span>
                    </label>

                    <input
                        type="text"
                        value={place}
                        onChange={(e) =>
                            setPlace(e.target.value)
                        }
                        placeholder="Ví dụ: Bệnh viện, phòng khám..."
                        className="w-full h-12 border rounded-xl px-3 outline-none focus:border-blue-500"
                    />

                </div>


                {/* BÁC SĨ */}
                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Bác sĩ / Khoa
                        <span className="font-normal text-gray-400 ml-1">
                            (không bắt buộc)
                        </span>
                    </label>

                    <input
                        type="text"
                        value={doctor}
                        onChange={(e) =>
                            setDoctor(e.target.value)
                        }
                        placeholder="Ví dụ: Khoa Tim mạch..."
                        className="w-full h-12 border rounded-xl px-3 outline-none focus:border-blue-500"
                    />

                </div>


                {/* GHI CHÚ */}
                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Nội dung / Ghi chú
                        <span className="font-normal text-gray-400 ml-1">
                            (không bắt buộc)
                        </span>
                    </label>

                    <textarea
                        value={note}
                        onChange={(e) =>
                            setNote(e.target.value)
                        }
                        placeholder="Ví dụ: mang theo kết quả xét nghiệm..."
                        rows={3}
                        className="w-full border rounded-xl px-3 py-3 outline-none focus:border-blue-500 resize-none"
                    />

                </div>


                {/* LƯU */}
                <button
                    onClick={handleSave}
                    disabled={saving}
                    className={`w-full mt-5 h-12 rounded-xl text-white font-bold ${
                        saving
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                    }`}
                >

                    <SaveOutlined className="mr-2" />

                    {saving
                        ? "Đang lưu..."
                        : "Lưu lịch tái khám"}

                </button>

            </div>


            {/* DANH SÁCH */}
            <div className="mt-7">

                <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                    Lịch tái khám
                </h2>

                <p className="text-gray-500 text-sm mt-1">
                    {syncWithAccount
                        ? "Các lịch tái khám được lưu theo tài khoản của bạn."
                        : "Các lịch tái khám bạn đã lưu trên thiết bị này."}
                </p>


                {loading ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <p className="text-sm text-gray-500">
                            Đang tải dữ liệu...
                        </p>

                    </div>

                ) : history.length === 0 ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <CalendarOutlined className="text-3xl text-gray-300" />

                        <p className="font-semibold text-gray-700 mt-3">
                            Chưa có lịch tái khám
                        </p>

                        <p className="text-sm text-gray-500 mt-1">
                            Cuộc hẹn bạn lưu sẽ xuất hiện tại đây.
                        </p>

                    </div>

                ) : (

                    <div className="space-y-3 mt-4">

                        {history.map((item) => (

                            <div
                                key={item.id}
                                className="bg-white border rounded-2xl p-4"
                            >

                                <div className="flex items-start justify-between">

                                    <div className="flex-1 pr-3">

                                        <div className="flex flex-wrap items-center gap-2">

                                            <span className="bg-blue-50 text-blue-700 font-bold text-sm px-3 py-1 rounded-lg">
                                                {formatDate(
                                                    item.appointmentDate
                                                )}
                                            </span>

                                            {item.appointmentTime && (

                                                <span className="bg-indigo-50 text-indigo-700 font-semibold text-sm px-3 py-1 rounded-lg">
                                                    {item.appointmentTime}
                                                </span>

                                            )}

                                        </div>


                                        {item.place && (

                                            <p className="font-semibold text-gray-800 mt-3">
                                                {item.place}
                                            </p>

                                        )}


                                        {item.doctor && (

                                            <p className="text-sm text-gray-600 mt-1">
                                                {item.doctor}
                                            </p>

                                        )}


                                        {item.note && (

                                            <div className="bg-gray-50 rounded-xl px-3 py-2 mt-3">

                                                <p className="text-sm text-gray-500">
                                                    {item.note}
                                                </p>

                                            </div>

                                        )}

                                    </div>


                                    <button
                                        onClick={() =>
                                            handleDelete(
                                                item.id
                                            )
                                        }
                                        className="w-10 h-10 rounded-xl bg-red-50 text-red-500 flex items-center justify-center flex-shrink-0"
                                        aria-label="Xóa lịch tái khám"
                                    >
                                        <DeleteOutlined />
                                    </button>

                                </div>

                            </div>

                        ))}

                    </div>

                )}

            </div>


            {/* LƯU Ý */}
            <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4 mt-7">

                <p className="font-semibold text-gray-800 text-sm">
                    Lưu ý
                </p>

                {syncWithAccount ? (

                    <p className="text-[13px] text-gray-600 leading-5 mt-1">
                        Lịch tái khám được lưu theo tài khoản đang đăng nhập và có thể được tải lại trên thiết bị khác khi sử dụng cùng tài khoản.
                    </p>

                ) : (

                    <p className="text-[13px] text-gray-600 leading-5 mt-1">
                        Lịch tái khám hiện được lưu trên trình duyệt của thiết bị bạn đang sử dụng.
                        Nếu xóa dữ liệu trình duyệt hoặc đổi thiết bị, lịch sử có thể không còn.
                    </p>

                )}

                <p className="text-[13px] text-gray-500 leading-5 mt-2">
                    Đây là công cụ hỗ trợ ghi nhớ lịch hẹn. Hãy đối chiếu thông tin với lịch hẹn chính thức từ cơ sở y tế.
                </p>

            </div>

        </div>
    );
}